import * as React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { useFxRateCache, useFxRateUtils } from '@/hooks/useFxRates';

export function CurrencyRatesPanel() {
  const { refreshRates } = useFxRateCache();
  const { getCommonCurrencies } = useFxRateUtils();
  const [isRefreshingRates, setIsRefreshingRates] = React.useState(false);

  const handleRefreshRates = async () => {
    setIsRefreshingRates(true);
    try {
      await refreshRates(getCommonCurrencies().slice(0, 10));
    } finally {
      setIsRefreshingRates(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Currency Rates</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm text-muted-foreground">
          Exchange rates are updated twice daily from Open Exchange Rates.
        </p>
        <Button
          variant="outline"
          onClick={handleRefreshRates}
          loading={isRefreshingRates}
          className="w-full"
        >
          Refresh Rates
        </Button>
      </CardContent>
    </Card>
  );
}
